import { isLanguageSupported } from "stream-chat-react";

// DECISION_026: the Stream chat chrome (unread banner, date separators, rail
// dates) used to render in whatever language the *library* resolved on its own —
// `client.user.language` from the Stream server, else the browser locale, else
// 'en' (stream-chat-react/dist/components/Chat/hooks/useChat.js). Our own
// language selector (TranslationContext) never appeared in that chain, which is
// how an EN seat on an en-US browser ended up with German date chrome.
//
// The fix is to hand <Chat> an explicit Streami18n instance, which means WE now
// own the language choice — including the honest gap: stream-chat-react ships
// chrome translations for 12 languages, our app offers 16. Anything the library
// does not have MUST land on English, never on the library's default-by-accident.

// The fallback for every app language the chat library has no bundle for.
export const STREAM_CHAT_FALLBACK_LANGUAGE = "en";

/**
 * Map an app language code (TranslationContext `currentLanguage`) onto a locale
 * the Stream chat library actually ships.
 *
 * - Region variants collapse onto their base subtag, so `pt-BR`/`pt-PT` → `pt`.
 * - Whether a base subtag is supported is asked of the library itself
 *   (`isLanguageSupported`), so the set never drifts from the installed version.
 * - Everything else — `ar`, `zh`, `zh-TW`, `da`, `hr`, empty, garbage — falls
 *   back to English. Explicitly. Not to German, not to the browser locale.
 *
 * @param {string} appLanguage e.g. "en", "de", "pt-BR", "zh-TW"
 * @returns {string} a locale stream-chat-react can translate, or "en"
 */
export const toStreamChatLanguage = (appLanguage) => {
	if (typeof appLanguage !== "string") return STREAM_CHAT_FALLBACK_LANGUAGE;

	const base = appLanguage.trim().toLowerCase().split(/[-_]/)[0];
	if (!base) return STREAM_CHAT_FALLBACK_LANGUAGE;

	return isLanguageSupported(base) ? base : STREAM_CHAT_FALLBACK_LANGUAGE;
};

export default toStreamChatLanguage;
